import { render, staticRenderFns } from "./SolRestaurante.vue?vue&type=template&id=47583ac7&scoped=true&"
import script from "./SolRestaurante.vue?vue&type=script&lang=js&"
export * from "./SolRestaurante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47583ac7",
  null
  
)

export default component.exports